module.exports = __webpack_public_path__ + "img/tappeto_gioco.971b84dd.jpg";